/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Script from 'next/script';
import Style from './RastreadoresOQueEV2.css';
import Container from '../../atoms/Container';

function RastreadoresOQueEV2() {
  return (
    <>
      <section id="rastreadores-o-que-e">
        <div className="o-que-e-1">
          <img className="image-1" src="assets/rastreadores/image-woman.png" alt="" />
          <Container>
            <div className="texts-div-1">
              <div>
                <h2 className="title">O que é?</h2>
                <p className="text">
                  Um serviço oferecido pela Santander Financiamentos em que é instalado um
                  rastreador no veículo que será financiado. Assim, possibilitamos mais segurança e
                  garantia durante todo o processo.
                  <br />
                  Saiba mais sobre o serviço
                </p>
              </div>
              {/* <div>
                <h2 className="title">Quais são os benefícios para o cliente?</h2>
                <p className="text">
                  O cliente Santander não paga nada pela instalação do rastreador e poderá monitorar
                  o veículo no aplicativo Ituran*, em tempo real e em todo o Brasil.
                  <br />
                  <span className="text-small">
                    *Para financiamentos realizados na nova plataforma.
                  </span>
                </p>
              </div> */}
            </div>
          </Container>
        </div>
        <div className="o-que-e-2">
          <img className="image-2" src="assets/rastreadores/image-man.png" alt="" />
          <Container>
            <div className="texts-div-2">
              <h2 className="title">Confira alguns benefícios para o lojista </h2>
              <ul className="list">
                <li className="list-item">
                  <div className="img-div">
                    <img
                      className="list-img"
                      src="assets/rastreadores/ic_companies_radar.svg"
                      alt=""
                    />
                  </div>
                  <p className="list-text">
                    Evita a <b>inadimplência</b> e<br className="break-line" /> permite uma carteira
                    <br className="break-line" /> de clientes <b>mais saudável</b>.
                  </p>
                </li>
                <li className="list-item">
                  <div className="img-div">
                    <img
                      className="list-img"
                      src="assets/rastreadores/ic_awards_medal.svg"
                      alt=""
                    />
                  </div>
                  <p>
                    <b>Mais garantia</b> e segurança
                    <br className="break-line" /> para evitar problemas
                    <br className="break-line" /> após a venda.
                  </p>
                </li>
                <li className="list-item">
                  <div className="img-div">
                    <img className="list-img" src="assets/rastreadores/ic_clock.svg" alt="" />
                  </div>
                  <p className="list-text">
                    O rastreador é colocado
                    <br className="break-line" /> <b>em até 24 horas</b>
                    <br className="break-line" /> após a solicitação.
                  </p>
                </li>
              </ul>
            </div>
          </Container>
        </div>
        <span className="bolinhas-white" />
        <span className="bolinhas-red" />
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default RastreadoresOQueEV2;
